import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcSigninService} from 'exc-signin';
import {DomSanitizer} from '@angular/platform-browser';
import {SearchSlimData} from '../search-slim/search-slim.component';
import {ModalPlanningHqHelpComponent} from '../modals/modal-planning-hq-help/modal-planning-hq-help.component';
import {ModalPlanningHqWarningComponent} from '../modals/modal-planning-hq-warning/modal-planning-hq-warning.component';
import {ModalDealerEditComponent} from '../modals/modal-dealer-edit/modal-dealer-edit.component';
import {ExcTab} from 'exc-tab';
import {DealerDetailsComponent} from '../dealer-details/dealer-details.component';
import {ModalPlanningHqApprovalComponent} from '../modals/modal-planning-hq-approval/modal-planning-hq-approval.component';
import {ModalPlanningHqAuditDetailComponent} from '../modals/modal-planning-hq-audit-detail/modal-planning-hq-audit-detail.component';
import {$0} from 'codelyzer/angular/styles/chars';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ModalPlanningHqSettingsComponent} from '../modals/modal-planning-hq-settings/modal-planning-hq-settings.component';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {ClientModalAuditCancelComponent} from '../client/modals/client-modal-audit-cancel/client-modal-audit-cancel.component';

@Component({
  selector: 'app-audit-planning',
  templateUrl: './audit-planning.component.html',
  providers: [CurrencyPipe, DatePipe],
  styles: []
})
export class AuditPlanningComponent extends ExcTranslation implements OnInit {

  @ViewChild('contextMenu') contextMenu;
  @ViewChild('trashMenu') trashMenu;
  @ViewChild('acceptWaitPanel') acceptWaitPanel;
  @ViewChild('mousecontext') mousecontext;
  @ViewChild('specialFiltersMenu') specialFiltersMenu;
  mandantID = null;
  trashMenuShown = false;
  mousecontextData = null;
  year = new Date().getFullYear();
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth() + 1;
  editMode = false;
  data: any[] = [];
  newAudits: any[] = [];
  deletedAudits: any[] = [];
  newAuditsProcessed = 0;
  deletedAuditsProcessed = 0;
  newAuditsFailed = 0;
  applyInProgress = false;
  pagingAactualPage = 1;
  pagingOldOffset;
  fcAnnounced = false;
  fcIncludeDoc = false;
  seletedAudits: any[] = [];
  dragged: {} = null;
  dataSort = {field: 'DealerName', order: 'asc'};
  menuCol: string = null;
  paging: any;
  pagingInstace: any;
  isLoading = false;
  paginator: any[];
  searchFields = {};
  level = 1;
  specialFlt = {PlanningStatus: null};
  colMonthMatch = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12
  };
  selectedAudits = [];
  sum = {
    Sum01: 0,
    Sum02: 0,
    Sum03: 0,
    Sum04: 0,
    Sum05: 0,
    Sum06: 0,
    Sum07: 0,
    Sum08: 0,
    Sum09: 0,
    Sum10: 0,
    Sum11: 0,
    Sum12: 0,
    Sum13: 0,
    Sum14: 0,
    Sum15: 0,
    Sum16: 0,
    Sum17: 0,
    Sum18: 0,
    HierarchyEnabled: false
  };
  colorFC = {
    CANCELLED: 'rgba(250, 169, 51, 0.9)',
    DONE: 'rgba(3, 181, 56, 0.9)',
    INPROG: 'rgba(88, 200, 224, 0.9)',
    EXPIRED: 'rgba(250, 169, 51, 0.9)',
    REJECTED: 'rgba(201, 48, 44, 0.9)',
    PLANNED: 'rgba(32, 83, 148, 0.9)',
    SELECTED: 'rgba(72, 31, 147, 0.9)',
    MOVETO: 'rgba(156, 255, 56, 0.9)',
    MOVEFROM: 'rgba(255, 56, 76, 0.9)',
    PLANNEDMOV: 'rgba(28,228,228,0.9)'
  };
  colorSC = {
    CANCELLED: 'rgba(250, 169, 51, 0.5)',
    DONE: 'rgba(3, 181, 56, 0.5)',
    INPROG: 'rgba(88, 200, 224, 0.5)',
    EXPIRED: 'rgba(250, 169, 51, 0.5)',
    REJECTED: 'rgba(201, 48, 44, 0.5)',
    PLANNED: 'rgba(32, 83, 148, 0.5)',
    SELECTED: 'rgba(72, 31, 147, 0.5)',
    MOVETO: 'rgba(156, 255, 56, 0.5)',
    MOVEFROM: 'rgba(255, 56, 76, 0.5)',
    PLANNEDMOV: 'rgba(28,228,228,0.5)'
  };
  levelIcons = {
    1: 'fa-user',
    2: 'fa-user-tie',
    3: 'fa-usere',
  };
  planMode: {Icon: string, Short: string, Key: string, Title: string, Color: string} = null;
  monthFlt = {month: null, mode: null};
  eraseMode = false;
  columnDefinition = {
      DealerLevel1: {span: 1, spanMin: 1, spanMax: 2, searchable: true, format: null},
      DealerLevel2: {span: 1, spanMin: 1, spanMax: 2, searchable: true, format: null},
      DealerLevel3: {span: 1, spanMin: 1, spanMax: 2, searchable: true, format: null},
      DealerName: {span: 2, spanMin: 1, spanMax: 4, searchable: true, format: null},
      DealerZip: {span: 1, spanMin: 1, spanMax: 1, searchable: true, format: null},
      DealerCity: {span: 2, spanMin: 2, spanMax: 4, searchable: true, format: null},
      DealerRating: {span: 1, spanMin: 1, spanMax: 2, searchable: true, format: null},
      DealerCategory: {span: 1, spanMin: 1, spanMax: 2, searchable: true, format: null},
      AuditsPerYear: {span: 1, spanMin: 1, spanMax: 1, searchable: true, format: null},
      LastAudits: {span: 3, spanMin: 3, spanMax: 3, searchable: false},
      DealerKB: {span: 1, spanMin: 1, spanMax: 3, searchable: true},
      DealerHFB: {span: 1, spanMin: 1, spanMax: 3, searchable: true, format: null},
      DealerWV: {span: 1, spanMin: 1, spanMax: 2,  searchable: true, format: 'FormatDate'}
  };
  constructor(private excRest: ExcRestService, private cdr: ChangeDetectorRef, private sani: DomSanitizer,
              private excSec: ExcSigninService, private excDss: DefaultSettingsService,
              private datePipe: DatePipe, private currencyPipe: CurrencyPipe) {
    super();
  }
  editDealer(x) {
    if (!this.excSec.isFeatured('CLI_DLR_CU')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    const _self = this;
    ExcCoreModule.showModal(ModalDealerEditComponent, null, 'm-alt', x, true).subscribe( r => {
      if (r && r.proceed === true) {
        r.dealer['DealerUPT'] = x['DealerUPT'];
        const url = _self.excRest.computeUrl('DealerU', {DealerID: x.DealerID});
        _self.excRest.post(url, r.dealer, {}).subscribe(ret => {
          Object.assign(x, ret.data.Header);
        });
      }
    });
  }
  setLevel(lvl) {
    if (this.applyInProgress === true) {
      return;
    }
    if (this.newAudits.length > 0 || this.deletedAudits.length > 0) {
      ExcCoreModule.showModal(ModalPlanningHqWarningComponent, null, 's', { movedAudits: 0, newAudits: this.newAudits.length, deletedAudits: this.deletedAudits.length, cancelledAudits: 0}, false).subscribe(ret => {
        if (ret && ret.proceed === true) {
          this.level = lvl;
          this.newAudits = [];
          this.deletedAudits = [];
          if (lvl === 2) {
            delete this.searchFields['DealerLevel1'];
          }
          if (lvl === 3) {
            delete this.searchFields['DealerLevel2'];
          }
          this.reload(1, null);
        }
      });
    } else {
      this.level = lvl;
      if (lvl === 2) {
        delete this.searchFields['DealerLevel1'];
      }
      if (lvl === 3) {
        delete this.searchFields['DealerLevel2'];
      }
      this.reload(1, null);
    }
  }
  setMonthFlt(f) {
    this.monthFlt.month = this.colMonthMatch[this.menuCol];
    this.monthFlt.mode = f;
    this.reload(null, null);
  }
  getMonthHeaderClass(m) {
    if (this.monthFlt.month !== null && this.monthFlt.month === m && this.monthFlt.mode !== null) {
      return 'th-warning';
    }
    return 'th-secondary';
  }
  getMonthMenuActiveClass(m) {
    if (m === null && this.monthFlt.month !== this.colMonthMatch[this.menuCol]) {
      return 'th-warning';
    }
    if (this.monthFlt.month === this.colMonthMatch[this.menuCol] && this.monthFlt.mode === m) {
      return 'th-warning';
    }
    return 'th-secondary';
  }
  getTooltip(x, col) {
      const ap: AuditPlan = x[col];
      if (ap !== null) {
        return ap.GetTooltip();
      }
    return '';
  }
  getPrevAuditStyle(state) {
    let col = '#fff';
    if (state !== null) {
      col = this.colorFC[state];
    }
    return {
      backgroundColor: col,
      padding: '0.3rem',
      margin: '0.15rem',
      borderRadius: '4px'

    };
  }
  getMenuheader() {
    let txt = '';
    switch (this.menuCol) {
      case 'Jan': txt = '01'; break;
      case 'Feb': txt = '02'; break;
      case 'Mar': txt = '03'; break;
      case 'Apr': txt = '04'; break;
      case 'May': txt = '05'; break;
      case 'Jun': txt = '06'; break;
      case 'Jul': txt = '07'; break;
      case 'Aug': txt = '08'; break;
      case 'Sep': txt = '09'; break;
      case 'Oct': txt = '10'; break;
      case 'Nov': txt = '11'; break;
      case 'Dec': txt = '12'; break;
    }
    return txt + '/' + this.year;
  }
  monthExport()  {
    let txt = 0;
    switch (this.menuCol) {
      case 'Jan': txt = 1; break;
      case 'Feb': txt = 2; break;
      case 'Mar': txt = 3; break;
      case 'Apr': txt = 4; break;
      case 'May': txt = 5; break;
      case 'Jun': txt = 6; break;
      case 'Jul': txt = 7; break;
      case 'Aug': txt = 8; break;
      case 'Sep': txt = 9; break;
      case 'Oct': txt = 10; break;
      case 'Nov': txt = 11; break;
      case 'Dec': txt = 12; break;
    }
    const url = this.excRest.computeUrl('PlanningHQExportMonth', {AuditYear: this.year, AuditMonth: txt});
    window.location.href = url;
  }
  monthApproval()  {
    let txt = 0;
    switch (this.menuCol) {
      case 'Jan': txt = 1; break;
      case 'Feb': txt = 2; break;
      case 'Mar': txt = 3; break;
      case 'Apr': txt = 4; break;
      case 'May': txt = 5; break;
      case 'Jun': txt = 6; break;
      case 'Jul': txt = 7; break;
      case 'Aug': txt = 8; break;
      case 'Sep': txt = 9; break;
      case 'Oct': txt = 10; break;
      case 'Nov': txt = 11; break;
      case 'Dec': txt = 12; break;
    }
    const _self = this;
    const url = this.excRest.computeUrl('PlanningHQMonthApproval', {AuditYear: this.year, AuditMonth: txt});
    this.excRest.get(url, {}).subscribe(ret => {
      ExcCoreModule.showModal(ModalPlanningHqApprovalComponent, null, 's', ret.data[0], false, null).subscribe();
    });
    this.contextMenu.hide();
  }
  getMenubodytext() {
    let cnt = 0;
    for (const x of this.newAudits) {
      if (x['Col'] === this.menuCol) {
        cnt = cnt + 1;
      }
    }
    if (cnt === 0) {
      return 'Keine Änderungen vorgenommen';
    } else if (cnt === 1) {
      return 'Ein neues Audit';
    } else if (cnt > 1) {
      return cnt + ' neue Audits';
    }
  }
  getMonthIconClass(pref, x, col) {
    let clr = '';

    const scLevel = x[pref + col + 'SCLevel'];
    const fcLevel = x[pref + col + 'FCLevel'];
    if (scLevel !== null ) {
      clr = this.levelIcons[scLevel];
    } else {
    }
    if (fcLevel !== null ) {
      clr = this.levelIcons[fcLevel];
    }
    return clr;
  }
  isAuditSet(x, col) {
   return true;
    // const ap: AuditPlan = x[col];
    // if (ap !== null) {
    //   return ap.IsBooked() || ap.Status === 'New' || ap.Status === 'Deleted';
    // }
    // return false;
  }
  getPlanIconClass(x, col) {
    if (x[col] !== null) {
      const ap: AuditPlan = x[col];
      if (ap.IsBooked()) {
        return 'far ' + ap.PlanType.Icon;
      }
      if (ap.Status === 'Deleted') {
        return 'far fa-trash-alt th-disabled';
      } else if (ap.Status === 'New') {
        return 'far ' + ap.PlanType.Icon + ' th-disabled';
      } else {
        return 'far ' + ap.PlanType.Icon;
      }
    }
  }
  getMonthStyle(isPrimary, pref, x, col) {
    let clr = isPrimary ? '#fff' : '#ddd';
    let planElement: AuditPlan = null;
    if (x[pref + col] !== null ) {
      planElement = x[pref + col];
      clr = planElement.GetColor();
    }
    let cursor = 'default';
    if (this.editMode === true) {
      if (this.year < this.currentYear) {
        cursor = 'not-allowed';
      } else if (this.year === this.currentYear && this.colMonthMatch[col] < this.currentMonth) {
        cursor = 'not-allowed';
      } else {
        if (planElement !== null) {
          if (this.eraseMode === true) {
            if (planElement.IsBooked() === false) {
              cursor = 'url(\'assets/scss/eraser-solid.svg\') 5 18, crosshair';
            } else {
              cursor = 'not-allowed';
            }
          } else {
            if (planElement.Status === 'New') {
              cursor = 'url(\'assets/scss/eraser-solid.svg\') 5 18, crosshair';
            }
          }
        } else {
          if (this.eraseMode === true) {
            cursor = 'not-allowed';
          } else {
            cursor = 'url(\'assets/scss/paint-brush-solid.svg\') 5 18, crosshair';
          }
        }
      }
    }

    // const padding = '0.5rem';
    // if (planElement !== null) {
      return {
        cursor: cursor,
        backgroundColor: clr,
        userSelect: 'none',
        height: '32px'
        // , paddingRight: '0.15rem'
        // , paddingBottom: '0.15rem'
        // , paddingTop: '0.25rem'
        // , paddingLeft: '0.25rem'
      };
    // } else {
    //   return {
    //     cursor: cursor,
    //     backgroundColor: clr,
    //     userSelect: 'none'
    //     , paddingRight: padding
    //     , paddingBottom: padding
    //
    //   };
    // }
  }
  showContextMenu(event, x, col) {
    if (this.excSec.isFeatured('CLI_ADT_U')) {
      if (x[col].length === 1) {
        event.preventDefault();
        this.mousecontextData = x[col][0];
        this.mousecontext.show(event);
      }
    }
    event.stopPropagation();
    event.cancelBubble = true;
    return false;
  }
  showContextMenuAudits(event, x) {
    event.preventDefault();
    this.mousecontextData = x;
    this.mousecontext.show(event);
    event.stopPropagation();
    event.cancelBubble = true;
    return false;
  }
  ShowContextDetails() {
    this.mousecontext.hide();
    ExcCoreModule.showModal(ModalPlanningHqAuditDetailComponent, null, 'm', this.mousecontextData,  false).subscribe(ret => {
      if (ret && ret.proceed === true) {
        this.excRest.post(this.excRest.computeUrl('PlanningHQAuditU_Edit',
          {AuditYear: this.currentYear, AuditID: this.mousecontextData['auftr_id']}),
          {auftr_ua: ret.data['auftr_ua'], auftr_brief: ret.data['Auftr_Brief']}, {}).subscribe(r => {
          this.mousecontextData['auftr_ua'] = ret.data['auftr_ua'];
          this.mousecontextData['Auftr_Brief'] = ret.data['Auftr_Brief'];
        });
      }
    });
  }
  showMonthContext(col, event) {
    // if (this.editMode === true) {
      this.menuCol = col;
      this.contextMenu.show(event);
    // }
  }

  handleMouseEnter(x, col, event) {
    const _self = this;
    if (this.editMode === true ) {
      if (this.year < this.currentYear) {
        return;
      } else if (this.year === this.currentYear && this.colMonthMatch[col] < this.currentMonth) {
        return;
      }
      if (this.eraseMode === true) {
        if (x[col] !== null) {
          const ap: AuditPlan = x[col];
          if (ap.IsBooked() === true) {
            return;
          }
          if (ap.PlanID !== null) {
            if (ap.Status === 'Deleted') {
             ap.Status = null;
              this.deletedAudits = this.deletedAudits.filter( (a) => {
                return !(a.PlanID === ap.PlanID);
              });
            } else {
              this.deletedAudits.push(ap);
              ap.Status = 'Deleted';
            }
          } else {
            this.newAudits =  this.newAudits.filter((a) => {
              return !(a.DealerID === x.DealerID && a.PlanMonth === _self.colMonthMatch[col]);
            });
            x[col] = null;
          }
        }
      } else {
        if (x[col] === null) {
          const ap: AuditPlan = new AuditPlan({}, this.excDss);
          ap.SetPlanType(this.planMode.Short);
          ap.PlanMonth = this.colMonthMatch[col];
          ap.PlanYear = this.year;
          ap.PlanID = null;
          ap.AuditLevel = _self.level;
          ap.DealerID = x['DealerID'];
          ap.Status = 'New';
          x[col] = ap;
          this.newAudits.push(ap);
        } else {
          const ap: AuditPlan = x[col];
          if (ap.Status === 'New') {
            this.newAudits =  this.newAudits.filter((a) => {
              return !(a.DealerID === x.DealerID && a.PlanMonth === _self.colMonthMatch[col]);
            });
            x[col] = null;
          }
        }
      }
    }
  }
  handleMouseUp(event) {
    // if (event.buttons === 1) {
    //   alert(this.newAudits.length + ' to plan');
    // }
  }

  getSortClass(f) {
    if (this.dataSort.field === f) {
      if (this.dataSort.order === 'asc') {
        return 'fa-sort-up';
      } else {
        return 'fa-sort-down';
      }
    } else {
      return 'fa-sort';
    }
  }
  setSort (f) {
    if (this.dataSort.field === f) {
      if (this.dataSort.order === 'asc') {
        this.dataSort.order = 'desc';
      } else {
        this.dataSort.order = 'asc';
      }
    } else {
      this.dataSort.field = f;
      this.dataSort.order = 'asc';
    }
    this.reload(1, null);
  }
  searchChanged(v: SearchSlimData) {
    if (v.value === null || v.value === '') {
      delete this.searchFields[v.field];
    } else {
      this.searchFields[v.field] = v.value;
    }
    this.reload(1, null);
  }
  showHelp() {
    ExcCoreModule.showModal(ModalPlanningHqHelpComponent, null, 'l', null,  true).subscribe(ret => {});
  }
  initialLoad() {
    if (this.applyInProgress === true) {
      return;
    }
    const _self = this;
    const metainfo = {
      dataFilter: {},
      dataSort: {},
      dataPaging: {pageNo: 1, pageSize: 17}
    };
    metainfo.dataSort[this.dataSort.field] = this.dataSort.order;
    this.isLoading = true;
    let url = '';
    if (this.monthFlt.mode !== null) {
      url = _self.excRest.computeUrl('AuditPlanningR_Summary', {AuditYear: _self.year, level: _self.level, monthFlt: _self.monthFlt.month, monthInc: _self.monthFlt.mode});
    } else {
      url = _self.excRest.computeUrl('AuditPlanningR_Summary', {AuditYear: _self.year, level: _self.level});
    }
    _self.excRest.get(url, {MetaInfo: metainfo}).subscribe(ret => {
      _self.data = ret.data.Planning;
      for (const a of _self.data) {
          a['LastYearDec'] = a['LastYearDec'] !== null ? new AuditPlan(a['LastYearDec'], _self.excDss) : null;
          a['LastYearNov'] = a['LastYearNov'] !== null ? new AuditPlan(a['LastYearNov'], _self.excDss) : null;
          a['LastYearOct'] = a['LastYearOct'] !== null ? new AuditPlan(a['LastYearOct'], _self.excDss) : null;
          a['NextYearJan'] = a['NextYearJan'] !== null ? new AuditPlan(a['NextYearJan'], _self.excDss) : null;
          a['NextYearFeb'] = a['NextYearFeb'] !== null ? new AuditPlan(a['NextYearFeb'], _self.excDss) : null;
          a['NextYearMar'] = a['NextYearMar'] !== null ? new AuditPlan(a['NextYearMar'], _self.excDss) : null;
          a['Jan'] = a['Jan'] !== null ? new AuditPlan(a['Jan'], _self.excDss) : null;
          a['Feb'] = a['Feb'] !== null ? new AuditPlan(a['Feb'], _self.excDss) : null;
          a['Mar'] = a['Mar'] !== null ? new AuditPlan(a['Mar'], _self.excDss) : null;
          a['Apr'] = a['Apr'] !== null ? new AuditPlan(a['Apr'], _self.excDss) : null;
          a['May'] = a['May'] !== null ? new AuditPlan(a['May'], _self.excDss) : null;
          a['Jun'] = a['Jun'] !== null ? new AuditPlan(a['Jun'], _self.excDss) : null;
          a['Jul'] = a['Jul'] !== null ? new AuditPlan(a['Jul'], _self.excDss) : null;
          a['Aug'] = a['Aug'] !== null ? new AuditPlan(a['Aug'], _self.excDss) : null;
          a['Sep'] = a['Sep'] !== null ? new AuditPlan(a['Sep'], _self.excDss) : null;
          a['Oct'] = a['Oct'] !== null ? new AuditPlan(a['Oct'], _self.excDss) : null;
          a['Nov'] = a['Nov'] !== null ? new AuditPlan(a['Nov'], _self.excDss) : null;
          a['Dec'] = a['Dec'] !== null ? new AuditPlan(a['Dec'], _self.excDss) : null;
      }
      _self.sum = ret.data.Summary;
      _self.mandantID = ret.data.Summary.MandantID;
      _self.paging = ret.paging.Planning ;
      this.isLoading = false;
    });
  }
  exportData() {

    const url = this.excRest.computeUrl('PlanningHQExport', {AuditYear: this.year});
    window.location.href = url;
  }
  showDealerDetails(x) {
    new ExcTab(x.DealerName, DealerDetailsComponent, x, x.DealerID, {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }
  applyChanges(e) {
    if (!this.excSec.isFeatured('AUDITC')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    if (this.newAudits.length === 0 && this.deletedAudits.length === 0) {
      return;
    }
    this.newAuditsProcessed = 0;
    this.deletedAuditsProcessed = 0;
    this.newAuditsFailed = 0;
    this.applyInProgress = true;
    this.acceptWaitPanel.show(e);
    this.processNextNewAudit();
    this.processNextDeletedAudit();
  }
  processNextNewAudit() {
    const _self = this;
    if (_self.newAudits.length === 0 || _self.newAuditsProcessed  === _self.newAudits.length) {
      return;
    }
    const a: AuditPlan = _self.newAudits[_self.newAuditsProcessed];
    const o = {
      DealerID: a.DealerID,
      AuditMonth: a.PlanMonth,
      AuditLevel: _self.level,
      Key: a.PlanType.Key,
      Short: a.PlanType.Short
    };
    const url = _self.excRest.computeUrl('AuditPlanningC', {AuditYear: _self.year});
    _self.excRest._putInternal(url, o , {} , true).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.newAuditsProcessed = _self.newAuditsProcessed + 1;
      } else if (ret && ret.rtval !== 1000) {
        _self.newAuditsProcessed = _self.newAuditsProcessed + 1;
        _self.newAuditsFailed = _self.newAuditsFailed + 1;
      }
      _self.checkProgress();
      _self.processNextNewAudit();
    });
  }
  processNextDeletedAudit() {
    const _self = this;
    if (_self.deletedAudits.length === 0 || _self.deletedAuditsProcessed  === _self.deletedAudits.length) {
      return;
    }
    const a: AuditPlan = _self.deletedAudits[_self.deletedAuditsProcessed];
    const url = _self.excRest.computeUrl('AuditPlanningD', {AuditYear: a.PlanYear, PlanID: a.PlanID});
    _self.excRest._deleteInternal(url, {} , {} , true).subscribe(ret => {
      if (ret && ret.rtval === 1040) {
        _self.deletedAuditsProcessed = _self.deletedAuditsProcessed + 1;
      }
      _self.checkProgress();
      _self.processNextDeletedAudit();
    });
  }
  closeApplyWindow() {
    this.acceptWaitPanel.hide();
    this.applyInProgress = false;
    this.newAuditsProcessed = 0;
    this.deletedAuditsProcessed = 0;
    this.newAudits = [];
    this.deletedAudits =  [];
    this.reload(this.paging.pagingPage, null);

  }
  checkProgress() {
    if (this.applyInProgress) {
      if (this.newAudits.length === this.newAuditsProcessed
        && this.deletedAudits.length === this.deletedAuditsProcessed) {
          this.reload(this.paging.pagingPage, null);
      } else {
        this.applyInProgress = true;
      }
    }
  }
  getColHeaderClass(col, idx, first) {
    const cls = [];
    cls.push('cell');
    if (idx === 0) {
      cls.push('list-fake');
    }
    if (col.span > 1) {
      cls.push('span-' + col.span);
    }
    return cls;
  }
  getColClass(col, idx, first) {
    const cls = [];
    // cls.push('cell');
    // if (idx === 0) {
    //   cls.push('list-fake');
    // }
    if (col.span > 1) {
      cls.push('span-' + col.span);
    }
    return cls;
  }
  getHeaderFillClass() {
    let sum = 12;
    for (const c of this.excDss.UserSettings['PHQColumns']) {
      sum -= c.span;
    }
    return sum > 0 ? 'span-' + sum : '';
  }
  getCellValue(row, col) {
    if (this.columnDefinition[col.col]['format'] === null) {
      return row[col.col];
    }
    if (this.columnDefinition[col.col]['format'] === 'money') {
      return row[col.col];
    } else {
      return this.datePipe.transform(row[col.col], this.getGlobal(this.columnDefinition[col.col]['format']));
    }
  }
  showSettings() {
    const _self = this;
    ExcCoreModule.showModal(ModalPlanningHqSettingsComponent, null, 'xl', {def: _self.columnDefinition}, false).subscribe( r => {
      if (r && r.proceed === true) {
        const sn = [];
        for (let i = 0; i < r.settingsNew.length; i++) {
          if (r.settingsNew[i].col !== null) {
            sn.push({col: r.settingsNew[i].col, span: r.settingsNew[i].span});
          }
        }
       _self.excDss.UserSettings['PHQColumns'] = sn;
       _self.excDss.Update();
      }
    });

  }
  reload(pageNo, event) {
    if (this.applyInProgress === true) {
      return;
    }
    const _self = this;
    this.paging.pagingPage = pageNo;
    const metainfo = {
      dataFilter: {},
      dataSort: {},
      dataPaging: {pageNo: pageNo, pageSize: 17}
    };
    if (this.specialFlt.PlanningStatus !== null) {
      if (this.specialFlt.PlanningStatus === 'Unequal') {
        metainfo.dataFilter['PlanningStatus'] = ['Below', 'Above'];
      } else {
        metainfo.dataFilter['PlanningStatus'] = this.specialFlt.PlanningStatus;

      }
    }
    this.isLoading = true;
    metainfo.dataSort[this.dataSort.field] = this.dataSort.order;
    for (const k of Object.keys(this.searchFields)) {
      // metainfo.dataFilter[k] = {value: this.searchFields[k], operator: 'LIKE'};
      metainfo.dataFilter[k] = this.searchFields[k];
    }
    let url = '';
    if (this.monthFlt.mode !== null) {
      url = _self.excRest.computeUrl('AuditPlanningR_Summary', {AuditYear: _self.year, level: _self.level, monthFlt: _self.monthFlt.month, monthInc: _self.monthFlt.mode});
    } else {
      url = _self.excRest.computeUrl('AuditPlanningR_Summary', {AuditYear: _self.year, level: _self.level});
    }

    _self.excRest.get(url, {MetaInfo: metainfo}).subscribe(ret => {
      _self.data = ret.data.Planning;
      for (const a of _self.data) {
        a['LastYearDec'] = a['LastYearDec'] !== null ? new AuditPlan(a['LastYearDec'], _self.excDss) : null;
        a['LastYearNov'] = a['LastYearNov'] !== null ? new AuditPlan(a['LastYearNov'], _self.excDss) : null;
        a['LastYearOct'] = a['LastYearOct'] !== null ? new AuditPlan(a['LastYearOct'], _self.excDss) : null;
        a['NextYearJan'] = a['NextYearJan'] !== null ? new AuditPlan(a['NextYearJan'], _self.excDss) : null;
        a['NextYearFeb'] = a['NextYearFeb'] !== null ? new AuditPlan(a['NextYearFeb'], _self.excDss) : null;
        a['NextYearMar'] = a['NextYearMar'] !== null ? new AuditPlan(a['NextYearMar'], _self.excDss) : null;
        a['Jan'] = a['Jan'] !== null ? new AuditPlan(a['Jan'], _self.excDss) : null;
        a['Feb'] = a['Feb'] !== null ? new AuditPlan(a['Feb'], _self.excDss) : null;
        a['Mar'] = a['Mar'] !== null ? new AuditPlan(a['Mar'], _self.excDss) : null;
        a['Apr'] = a['Apr'] !== null ? new AuditPlan(a['Apr'], _self.excDss) : null;
        a['May'] = a['May'] !== null ? new AuditPlan(a['May'], _self.excDss) : null;
        a['Jun'] = a['Jun'] !== null ? new AuditPlan(a['Jun'], _self.excDss) : null;
        a['Jul'] = a['Jul'] !== null ? new AuditPlan(a['Jul'], _self.excDss) : null;
        a['Aug'] = a['Aug'] !== null ? new AuditPlan(a['Aug'], _self.excDss) : null;
        a['Sep'] = a['Sep'] !== null ? new AuditPlan(a['Sep'], _self.excDss) : null;
        a['Oct'] = a['Oct'] !== null ? new AuditPlan(a['Oct'], _self.excDss) : null;
        a['Nov'] = a['Nov'] !== null ? new AuditPlan(a['Nov'], _self.excDss) : null;
        a['Dec'] = a['Dec'] !== null ? new AuditPlan(a['Dec'], _self.excDss) : null;
      }
      _self.sum = ret.data.Summary;
      _self.mandantID = ret.data.Summary.MandantID;
      _self.paging = ret.paging.Planning ;
      this.isLoading = false;
    });
  }

  ngOnInit() {
    this.planMode = this.excDss.MandantSettings.AuditPlanning.Types[0];
    this.initialLoad();
  }
  getAvatarClass(x) {
    if (x.auftr_art === 16) {
      if (x.Auftr_IsPicked) {
        return 'fa-mobile th-warning';
      } else {
        return 'fa-mobile th-secondary';
      }
    } else {
      if (x.Auftr_IsPicked) {
        return 'fa-user-secret th-warning';
      } else {
        return 'fa-user-secret th-secondary';
      }
    }
  }
  getAttractorTip(x) {
    if (x.auftr_art === 16) {
      switch (x.auftr_status) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
          break;
        case 8:
        case 9:
          if (x.ScRejected === true) {
            return this.getGlobal('Rejected');
          } else {
            if (x.ScEnded === true) {
              return this.getGlobal('Done');
            } else {
              return this.getGlobal('Expired');
            }
          }
          break;
        case 10:
          return this.getGlobal('Cancelled');
          break;
      }
    } else {
      switch (x.auftr_status) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          return this.getGlobal('InProgress');
          break;
        case 8:
        case 9:
          return this.getGlobal('Done');
          break;
        case 10:
          return this.getGlobal('Cancelled');
          break;
      }
    }
  }
  getKSPClass(x) {
    let s = 0;
    for (const k of Object.keys(this.colMonthMatch)) {
      for (let i = 0; i < x[k].length; i++) {
        if (x[k][i].auftr_status !== 10) {
          s = s + 1;
        }
      }
    }
    if (s < x.AuditsPerYear) {
      return ['th-bold', 'th-danger'];
    }
    return [];
  }
  getAttractorClass(x) {
    if (x.auftr_art === 16) {
      switch (x.auftr_status) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
          break;
        case 8:
        case 9:
          if (x.ScRejected === true) {
            return 'ch-danger fa-exclamation';
          } else {
            if (x.ScEnded === true) {
              return 'ch-success fa-check';
            } else {
              return 'ch-warning fa-clock';
            }
          }
          break;
        case 10:
          return 'ch-warning fa-ban';
          break;
      }
    } else {
      switch (x.auftr_status) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          return 'ch-secondary fa-cogs';
          break;
        case 8:
        case 9:
          return 'ch-success fa-check';
          break;
        case 10:
          return 'ch-warning fa-ban';
          break;
      }
    }
  }
  applySpecial() {
    this.specialFiltersMenu.hide();
    this.reload(this.paging.pagingPage, null);
  }
  resetSpecial() {
    this.specialFlt.PlanningStatus = null;
    this.reload(this.paging.pagingPage, null);
    this.specialFiltersMenu.hide();
  }
  showSpecialFilters(event) {
    this.specialFiltersMenu.show(event);
  }
  GetPaginator(length?, element?): string[] {
    let reRender = false;
    if (element) {
      if (element.offsetWidth > 1000) {
        length = 13;
      }
      if (element.offsetWidth < 1000) {
        length = 9;
      }
      if (element.offsetWidth < 500) {
        length = 7;
      }
      if (element.offsetWidth < 300) {
        length = 5;
      }
      if (element.offsetWidth < 200) {
        length = 3;
      }
      reRender = reRender || (element.offsetWidth > 0 && this.pagingOldOffset !== element.offsetWidth);
    }
    if (!this.paging) {
      return;
    }
    reRender = reRender || this.pagingAactualPage !== this.paging.pagingPage || this.paging !== this.pagingInstace;
    if (!reRender) {
      return this.paginator;
    }
    if (element) {
      this.pagingOldOffset = element.offsetWidth;
    }
    this.pagingInstace = this.paging;
    this.pagingAactualPage = this.paging.pagingPage;
    let paginatorItems: any[] = [];
    const maxLength: number = (!length) ? 9 : length;
    if (maxLength < 5) {
      paginatorItems.push({label: '<', value: this.paging.pagingPage === 1 ? 1 : this.paging.pagingPage - 1});
      paginatorItems.push({label: this.paging.pagingPage, value: this.paging.pagingPage});
      paginatorItems.push({
        label: '>',
        value: this.paging.pagingPage === this.paging.pagingTotalPages ? this.paging.pagingTotalPages : this.paging.pagingPage + 1
      });
      this.paginator = paginatorItems;
      return paginatorItems;
    }

    let minDots;
    let maxDots;
    const middleNumbers = [];
    for (let i: any = 2; i < this.paging.pagingTotalPages; i++) {

      if (this.paging.pagingPage <= (maxLength + 1) / 2 && i < this.paging.pagingPage) {
        middleNumbers.push({label: i, value: i});
      } else if ((this.paging.pagingPage <= maxLength - 4 && i > this.paging.pagingPage
        && i < (maxLength - 1)) || this.paging.pagingTotalPages === maxLength) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage > this.paging.pagingTotalPages - (maxLength + 1) / 2 && i > this.paging.pagingPage) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage > this.paging.pagingTotalPages - maxLength - 4
        && i < this.paging.pagingPage && i > this.paging.pagingTotalPages - (maxLength - 2)) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage - i >= ((maxLength - 3) / 2)) {
        minDots = {label: '...', value: (i - ((maxLength - 5) / 2) < 2) ? 2 : i - ((maxLength - 5) / 2)};
      } else if (this.paging.pagingPage - i <= -1 * ((maxLength - 3) / 2)) {
        maxDots = maxDots || {
          label: '...',
          value: (i + ((maxLength - 5) / 2)) > this.paging.pagingTotalPages - 1
            ? this.paging.pagingTotalPages - 1
            : i + ((maxLength - 5) / 2)
        };
      } else {
        if ((this.paging.pagingPage - i > ((maxLength - 3) / 2)) || (this.paging.pagingPage - i < ((maxLength - 3) / 2))) {
          middleNumbers.push({label: i, value: i});
        }
      }
    }

    if (this.paging.pagingTotalPages > 0) {
      paginatorItems.push({label: '1', value: 1});
    }
    if (minDots) {
      paginatorItems.push(minDots);
    }

    // if(middleNumbers.length < (maxLength - 3) )

    paginatorItems = paginatorItems.concat(middleNumbers);

    if (maxDots) {
      paginatorItems.push(maxDots);
    }

    if (this.paging.pagingTotalPages > 1) {
      paginatorItems.push({label: this.paging.pagingTotalPages, value: this.paging.pagingTotalPages});
    }
    this.paginator = paginatorItems;
    return paginatorItems;
  }
}
export class AuditPlan extends ExcTranslation {
  public PlanID: string = null;
  public AuditID: number = null;
  public DealerID: number;
  public PlanYear: number;
  public PlanMonth: number;
  public AuditLevel: number = 1;
  private _planType: PlanType = null;
  private _planTypeShort: string;
  private _status: string = null;
  public get PlanType() {
    return this._planType;
  }
  public get Status() { return this._status; }
  public set Status(newStatus: string) { this._status = newStatus; }
  public SetPlanType(pt: string = null) {
    this._planType = null;
    this._planTypeShort = pt;
    for (const x of this.excDss.MandantSettings.AuditPlanning.Types) {
      if (x.Short === this._planTypeShort) {
        this._planType = Object.assign({}, x);
        break;
      }
    }
  }
  public GetColor() {
    if (this.PlanType !== null) {
      if (this.AuditID !== null) {
        return 'rgba(' + this.PlanType.Color + ',1.0)';
      }
      return 'rgba(' + this.PlanType.Color + ',0.4)';
    }
    return '#fff';
  }
  public GetTooltip() {
    let tt = this.PlanType.Title;
    if (this.IsBooked() === true) {
      tt = tt + '\r\n' + this.getGlobal('AuditAlreadyOrdered') + ' (' + this.AuditID + ')';
    }
    if (this._status === 'New') {
      tt = tt + '\r\n' + this.getGlobal('AuditToBeAdded') ;
    }
    if (this._status === 'Deleted') {
      tt = tt + '\r\n' + this.getGlobal('AuditToBeDeleted') ;
    }
    return tt;
  }
  public IsBooked() { return this.AuditID !== null; }
  constructor(data?: any, private excDss?: DefaultSettingsService) {
    super();
    this.PlanID = data && data['PlanID'] || null;
    this.AuditID = data && data['AuditID'] || null;
    this.DealerID = data && data['DealerID'] || null;
    this.PlanYear = data && data['PlanYear'] || null;
    this.PlanMonth = data && data['PlanMonth'] || null;
    this.SetPlanType(data && data['PlanType'] || null);
  }
}
export class PlanType {
  public Title: string;
  public Key: string;
  public Icon: string;
  public Short: string;
  public Color: string;
  constructor(data: any) {
    this.Title = data['Title'];
    this.Key = data['Key'];
    this.Icon = data['Icon'];
    this.Short = data['Short'];
    this.Color = data['Color'];
  }
}
